/**
 * SchedulesPage
 *
 * Unified schedule management page backed by Temporal.
 * Replaces the old WorkflowSchedulesPage with a simpler design:
 * - All schedules use cron expressions (no once/recurring)
 * - Execution history viewed in Temporal Web UI (not embedded)
 */

import { useState, useCallback } from 'react';
import { ScheduleList } from '@/features/schedules/components/ScheduleList';
import { ScheduleFormDialog } from '@/features/schedules/components/ScheduleFormDialog';
import type { UnifiedScheduleResponse } from '@/types/schedule';

export function SchedulesPage() {
  // Dialog state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState<UnifiedScheduleResponse | null>(null);

  // Handle create
  const handleCreate = useCallback(() => {
    setSelectedSchedule(null);
    setDialogOpen(true);
  }, []);

  // Handle edit
  const handleEdit = useCallback((schedule: UnifiedScheduleResponse) => {
    setSelectedSchedule(schedule);
    setDialogOpen(true);
  }, []);

  // Handle dialog close
  const handleDialogClose = useCallback((open: boolean) => {
    setDialogOpen(open);
    if (!open) {
      setSelectedSchedule(null);
    }
  }, []);

  return (
    <div className="h-[calc(100vh-4rem)]">
      <div className="h-full overflow-y-auto p-6 bg-gray-50">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">定时任务管理</h1>
          <p className="text-sm text-gray-500 mt-1">
            基于 Temporal 的统一调度管理，支持系统任务和工作流调度
          </p>
        </div>

        <ScheduleList onCreate={handleCreate} onEdit={handleEdit} />
      </div>

      <ScheduleFormDialog
        open={dialogOpen}
        onOpenChange={handleDialogClose}
        schedule={selectedSchedule}
      />
    </div>
  );
}
